import type { RSVPFormData, RSVPApiResponse } from '@shared/types';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.nikiniandkeith.com';

/**
 * API client for RSVP submission
 */
export async function submitRSVP(data: RSVPFormData): Promise<RSVPApiResponse> {
  const response = await fetch(`${API_URL}/api/rsvp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  const result = await response.json();
  return result;
}

/**
 * Health check API
 */
export async function checkHealth(): Promise<{ status: string }> {
  const response = await fetch(`${API_URL}/api/health`);
  return response.json();
}
